<template>
  <b-container fluid="xxl">
    <b-row class="mt-5">
        <b-col >
            <b-navbar-brand
                to="/dashboard"
                :class="getLogoWidthClass()"
                @click="$root.$emit('track', {source: null, target: null, button: 'Logo'})"
            >
                <b-img :src="getLogo()" :width="getLogoWidth()" fluid />
            </b-navbar-brand>

        </b-col>
        <b-col>
           <b-navbar class="wl-nav">
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown
                        class="mr-3"
                        text="Administration"
                        right
                        v-if="getUserLevel >= 30"
                    >
                        <template slot="button-content">
                            <font-awesome-icon
                                :icon="['fa', 'gears']"
                                class="cursor-pointer navlink"
                            />
                        </template>
                    

                        <b-dropdown-item
                            to="/adminProductList"
                        >{{ $t('NAV_LINK_TEXT_ADMIN_PRODUCT') }}</b-dropdown-item>

                        <b-dropdown-item 
                            to="/userList"
                        >{{ $t('NAV_LINK_TEXT_ADMIN_USER') }}</b-dropdown-item>
                        <b-dropdown-item
                            to="/companyList"
                        >{{ $t('NAV_LINK_TEXT_ADMIN_COMPANIES') }}</b-dropdown-item>
                        <b-dropdown-item
                            to="/adminPageGroups"
                        >{{ $t('NAV_LINK_TEXT_ADMIN_PAGE_GROUPS') }}</b-dropdown-item>
                        <b-dropdown-item
                            to="/adminPageTags"
                        >{{ $t('NAV_LINK_TEXT_ADMIN_PAGE_TAGS') }}</b-dropdown-item>
                        <b-dropdown-item
                            to="/adminPageTransfer"
                        >{{ $t('NAV_LINK_TEXT_ADMIN_PAGE_TRANSFER') }}</b-dropdown-item>


                    </b-nav-item-dropdown>

                    <!--<b-nav-item-dropdown
                        class="mr-3"
                        text="Administration"
                        right
                        v-if="getUserLevel >= 30"
                    >
                        <template slot="button-content">
                            <font-awesome-icon
                                :icon="['fa', 'magic']"
                                class="cursor-pointer navlink"
                            />
                        </template>
                    

                    <b-dropdown-item
                            to="/adminDesignEditor"
                        >{{ $t('NAV_LINK_TEXT_ADMIN_DESIGN') }}</b-dropdown-item>
                    </b-nav-item-dropdown>-->


                    <b-nav-item
                        href="/"
                        class="wl-nav__log-out bg-cta rounded-circle"
                        @click="$root.$emit('track', {source: null, target: null, button: 'logout'})"
                    >
                        <font-awesome-icon
                            :icon="['fa', 'sign-out-alt']"
                            
                        />
                    </b-nav-item>
                </b-navbar-nav>
            </b-navbar>
        </b-col>
    </b-row>
   
  </b-container>
</template>

<script>


import { mapGetters } from 'vuex';
//import * as CONFIG from '@/wl-config/wl-app-config';
const CONFIG =  require(`@/wl-config/${process.env.VUE_APP_WL_FOLDER}/wl-app-config`)

export default {
  name: "viewHeader",
  data() {
    return {
      wlAppConstants: CONFIG.WLCONFG
    }
  },
  computed: {
    ...mapGetters([
      'getUserLevel'
    ]),
  }, methods: {
    getLogo() {   
      return require(`@/wl-config/${process.env.VUE_APP_WL_FOLDER}/assets/images/${this.wlAppConstants.LOGO}`);
    },
    getLogoWidth() {

      if (`${process.env.VUE_APP_WL_FOLDER}/assets/images/${this.wlAppConstants.LOGO_WIDTH}` === undefined) {
        return 210;
      } else {
        return `${process.env.VUE_APP_WL_FOLDER}/assets/images/${this.wlAppConstants.LOGO_WIDTH}`;
      }
    },
    getLogoWidthClass() {
      if (`${this.wlAppConstants.LOGO_WIDTH_CLASS}` === undefined) {
        return 'w-100';
      } else {
        return `${this.wlAppConstants.LOGO_WIDTH_CLASS}`;
      }
    }
  }
}
</script>

<style scoped>
</style>